import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon } from './Icons.jsx';
import { useStore } from '../context/StoreContext.jsx';
import { money, sizeRank } from '../config/brand.js';
import { ik, ikSet } from '../utils/imagekit.js';

export const discountOf = (p) =>
  p.originalPrice && p.originalPrice > p.price ? Math.round((1 - p.price / p.originalPrice) * 100) : 0;

export function Placeholder({ name }) {
  return <div className="ph" aria-label={name}><span>{(name || '').slice(0, 1)}</span></div>;
}

export default function ProductCard({ product }) {
  const { wishlist, toggleWishlist } = useStore();
  const off = discountOf(product);
  const soldOut = (product.stock || 0) <= 0;
  const saved = wishlist.includes(product.id);
  const second = product.images && product.images[1];
  const sizes = [...(product.sizes || [])].sort((a, b) => sizeRank(a.size) - sizeRank(b.size));

  return (
    <article className="card">
      <Link to={`/product/${product.id}`} className="card__media">
        {product.image ? <img src={ik(product.image, 600)} srcSet={ikSet(product.image, [300, 600, 900])} sizes="(max-width: 700px) 50vw, 25vw" alt={product.name} loading="lazy" /> : <Placeholder name={product.name} />}
        {second && <img className="card__alt" src={ik(second, 600)} srcSet={ikSet(second, [300, 600, 900])} sizes="(max-width: 700px) 50vw, 25vw" alt="" loading="lazy" />}
        <div className="card__badges">
          {off > 0 && !soldOut && <span className="badge badge--sale">-{off}%</span>}
          {soldOut && <span className="badge badge--dark">Sold out</span>}
          {!soldOut && !off && product.newArrival && <span className="badge">New</span>}
        </div>
      </Link>
      <button
        type="button"
        className={`card__heart${saved ? ' is-on' : ''}`}
        onClick={() => toggleWishlist(product.id)}
        aria-label={saved ? 'Remove from wishlist' : 'Add to wishlist'}
      >
        <HeartIcon filled={saved} width={18} height={18} />
      </button>
      <Link to={`/product/${product.id}`} className="card__info">
        <h3 className="card__name">{product.name}</h3>
        <p className="card__price">
          {off > 0 && <s>{money(product.originalPrice)}</s>} <span>{money(product.price)}</span>
        </p>
        {sizes.length > 0 && (
          <p className="card__sizes">
            {sizes.map((s) => (
              <span key={s.size} className={s.stock <= 0 ? 'is-out' : ''}>{s.size}</span>
            ))}
          </p>
        )}
      </Link>
    </article>
  );
}
